export default defineAppConfig({
  ui: {
    colors: {
      primary: 'cantook-blue',
      secondary: 'blue',
      neutral: 'slate',
      info: 'blue',
      success: 'green',
      warning: 'yellow',
      error: 'red',
    },

    button: {
      slots: {
        base: 'cursor-pointer justify-center',
      },
    },

    modal: {
      slots: {
        footer: 'flex justify-end items-center gap-1.5 p-4 sm:px-6',
        title: 'font-body-l-strong text-(--ui-text-muted)',
      },
      variants: {
        fullscreen: {
          false: {
            content:
              'top-12 left-1/2 -translate-x-1/2 translate-y-0 w-[calc(100vw-2rem)] max-w-lg max-h-[calc(100dvh-2rem)] sm:max-h-[calc(100dvh-4rem)] rounded-[calc(var(--ui-radius)*2)] shadow-lg ring ring-(--ui-border)',
          },
        },
      },
    },

    skeleton: {
      base: 'animate-pulse bg-black/10 dark:bg-white/10',
    },
  },
});
